module.exports = __webpack_public_path__ + "img/Apoptosis-BLCA_GSE171351.aa850836.png";